import React from 'react';

import { Badge, Text } from '@chakra-ui/react';

type CustomBadgeProps = {
    selectionOptions: string[];
};

const CustomBadge: React.FC<CustomBadgeProps> = ({ selectionOptions }) => {
    const [options, setOptions] = React.useState<string[]>(selectionOptions);

    React.useEffect(() => {
        const sliceSelectedOption = selectionOptions?.slice(0, 3);
        setOptions(sliceSelectedOption);
    }, [selectionOptions]);

    return (
        <>
            {options.map(option => (
                <Badge
                    key={option}
                    p={2}
                    borderRadius="0.375rem"
                    variant="subtle"
                    textTransform="capitalize"
                >
                    <Text
                        maxW="96px"
                        overflow="hidden"
                        textOverflow="ellipsis"
                        whiteSpace="nowrap"
                        fontSize="sm"
                        color="titleText"
                        fontWeight={400}
                    >
                        {option?.toLowerCase()}
                    </Text>
                </Badge>
            ))}
        </>
    );
};

export default CustomBadge;
